import { render, staticRenderFns } from "./orders-box.vue?vue&type=template&id=fb2cdfc0&scoped=true&"
import script from "./orders-box.vue?vue&type=script&lang=js&"
export * from "./orders-box.vue?vue&type=script&lang=js&"
import style0 from "./orders-box.vue?vue&type=style&index=0&id=fb2cdfc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2cdfc0",
  null
  
)

export default component.exports